import { render, staticRenderFns } from "./GlAccountDetail.vue?vue&type=template&id=8b3c782e&"
import script from "./GlAccountDetail.vue?vue&type=script&lang=js&"
export * from "./GlAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./GlAccountDetail.vue?vue&type=style&index=0&id=8b3c782e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports